<template>
    <div>
        <StepsBar :currentStep="currentStep" />
        <!-- 其他页面内容 -->
    </div>
    <div class="background-image"></div>
    <div class="login-container">
        <div class="login-box">
            <h2>{{ $t("welcome") }} <small><span class="username">{{ username }} </span></small>
            <span class="logout-icon" @click="logout" :title="$t('logout')">
                <i class="fas fa-sign-out-alt"></i>
            </span>
            </h2>
        
            <div class="game-section">
                <label for="server-select" class="normal-label">{{ $t("select_server") }}：</label>
                <select class="server-select" v-model="selectedServer">
                    <option v-for="server in servers" :value="server.ID" :key="server.ID" v-bind:merge="server.merge" :state="server.State">{{ server.Name }}</option>
                </select>
                <div class="game-name">{{ getGameName() }}</div>
                <button class="submit-button" :disabled="isButtonDisabled" @click="showConfirmation">{{ $t("logout_account") }}</button>
            </div>
        </div>
    </div>
</template>
  

<script>
import instance from '@/util/axios.js';
import { getLocal, removeLocal } from '@/util/help.js';
import { ElMessageBox } from 'element-plus';
import StepsBar from '@/components/StepsBar.vue';
    
  export default {
    name: 'UserComponent',
    components: {
        StepsBar
    },
    data() {
      return {
        username: getLocal("auth"), // 假设登录成功后获取到的用户名
        selectedServer: null, // 选中的游戏区服
        selectedServerObj: null,
        servers: [],
        isDisabled: true,
        currentStep: 3
      };
    },
    mounted() {
        if (!getLocal("read_agreement")) {
            this.$router.push("/user/agreement");
        }
        this.getServers();
    },
    computed: {
        isButtonDisabled() {
            if (this.isDisabled) {
                return true;
            }

            return false;
        }
    },
    methods: {
        logout() {
            // 处理退出登录逻辑http://127.0.0.1:5000/ccc
            // http://192.168.2.73:8089/logout
            instance.get("/api/v1/userweb/logout")
            .then(response => {
                console.log(response.data);
                removeLocal("auth");
                // this.$router.push("/login");
                window.location.reload();
            })
            .catch(error => {
                console.log(error)
                
                // this.$router.push("/login");
            })
        },
        getGameName() {
            // 根据选中的区服获取游戏名称的逻辑，返回游戏名称
            if (this.selectedServer) {
                this.selectedServerObj = this.servers.find(server => String(server.ID) === String(this.selectedServer));
                if (this.selectedServerObj) {
                    if (String(this.selectedServerObj.State) == "4") {
                        this.isDisabled = true
                        return this.$t("server_weihu"); // The server is currently undergoing maintenance.
                    }
                    const allservers = getLocal("servers").split(',').map(Number)
                    if (allservers.find(serverid => String(serverid) == String(this.selectedServerObj.ID))) {
                        this.isDisabled = false
                        return this.$t("check_player"); 
                    }
                    // const show_str = `id:${this.selectedServerObj.ID}` + "name:" + this.selectedServerObj.Name + "merge:" + this.selectedServerObj.Merge + "state:" + this.selectedServerObj.State
                    this.isDisabled = true
                    return this.$t("no_check_player");  
                }
            }
        },
        getServers() {
            if (this.servers.length <= 0)
            {
                instance.get("/api/v1/userweb/function/getserverlist")
                .then(response => {
                    if (response.data.status == 0) {
                        const data = response.data.data
                        this.servers = data.servers
                    } else {
                        console.log(response.data.status)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },
        showConfirmation() {
            ElMessageBox.confirm(this.$t("are_you_sure"), this.$t("confirm"), {
                confirmButtonText: this.$t("ok"),
                cancelButtonText: this.$t("cancel"),
                type: 'warning'
            }).then(() => {
                // 用户点击了确认按钮后的操作
                this.submitForm();
            }).catch(() => {
                // 用户点击了取消按钮后的操作
            });
        },
        submitForm() {
            // 提交表单的逻辑
            if (!this.selectedServerObj) {
                alert(this.$t("please_select_server"));
                return; 
            }
            // http://192.168.2.73:8089/zhuxiao
            instance.post("/api/v1/userweb/cancel", {
                serverid: this.selectedServerObj.ID,
                mergeid: this.selectedServerObj.Merge
            })
            .then(response => {
                if (response.data.status == 0) {
                    alert(this.$t("logout_account_successful"));
                } else if(response.data.status == 1) {
                    alert(this.$t("logout_account_has"));
                } else if(response.data.status == 2) {
                    alert(this.$t("logout_no_player"));
                } else {
                    if (response.data.status == 50004) {
                        alert(this.$t("auth_timeout"));
                        removeLocal("auth");
                        window.location.reload();
                    } else {
                        alert(this.$t("error_logout_account_failed"));
                        console.log(response.data);
                    }
                }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 403) {
                        // Handle 403 Forbidden error
                        console.log(error);
                        console.log('Received HTTP 403 Forbidden error');
                        alert(this.$t("auth_timeout"));
                        removeLocal("auth");
                        window.location.reload();
                        // instance.get("/api/v1/userweb/get_csrf_token")
                        // .then(response => {
                        //     if (response.data.status == 0) {
                        //         // const data = response.data.data
                        //         // alert(data.csrfToken);
                        //         // setLocal("csrfToken", data.csrfToken)
                        //         // setLocal("csrfToken", response.headers['x-csrf-token'])
                        //     } else {
                        //         alert(this.$t("error_exception")); // 页面异常，请重新刷新页面
                        //         console.log(response.data.status);
                        //     }
                        // })
                        // .catch(error => {
                        //     alert(error)
                        //     this.$router.push("/maintain");
                        // })
                    } else if (error.response.status === 429) {
                        alert(this.$t("error_too_many_request"));
                    } else {
                        // Handle other errors
                        console.log('Received other error:', error.response.status);
                        alert(this.$t("error_server_response"))
                    }
                } else {
                    // Handle request error (no response received)
                    console.log('Request error:', error.message);
                    alert(this.$t("error_server_response"))
                }
                
            })
        }
    }
  };
</script>
  
<style>
    .username {
        text-decoration: underline;
        color: rgb(66, 131, 192);
    }

    .logout-icon {
        /* 设置图标样式 */
        color: rgb(194, 102, 102); /* 设置鼠标悬停时的颜色 */
        margin-left: auto;
    }

    .logout-icon:hover {
        color: rgb(121, 180, 180); /* 设置鼠标悬停时的颜色 */
        cursor: pointer; /* 将鼠标样式设置为手型 */
    }

    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url('../../public/images/back.jpg');
        background-size: cover;
        background-position: center;
        filter: none;
        z-index: -1;
    }

    .login-container {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .login-box {
        width: 400px;
        padding: 40px;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }


    .normal-label {
        font-size: 16px;
        font-weight: bold;
    }
  
    .server-select {
        padding: 10px 20px;
        font-size: 16px;
        border-radius: 5px;
        border: 1px solid #ccc;
    }
  
    .game-name {
        font-size: 24px;
        margin: 20px 0;
    }
  
    .submit-button {
        padding: 10px 20px;
        background-color: #62619c;
        color: #fff;
        border: none;
        border-radius: 5px;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }
    
    .submit-button:hover {
        background-color: #d44b69;
    }

    .submit-button:disabled {
        background-color: gray; /* 设置禁用状态下的背景色 */
        cursor: not-allowed; /* 设置禁用状态下的鼠标指针样式 */
    }

    .confirmation-dialog {
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
        text-align: center;
    }

</style>